import {useCallback} from 'react';

import {useCommonEventHook} from 'src/hooks/use-common-event-hook';
import {updateColumnOrder} from 'src/openapi/admin/apis/SearchTemplateApi';
import {useAppDispatch} from 'src/store/hooks';

import type {UserSearchTemplate} from 'src/openapi/admin/models/UserSearchTemplate';

type Props = {
    onSuccess: () => void,
    onFail: (error: string) => void,
};

export const useUpdateColumnOrder = ({onSuccess, onFail}: Props) => {
    const apiDispatch = useAppDispatch();

    const eventAction = useCallback((template: UserSearchTemplate) => apiDispatch(updateColumnOrder({
        templateId: template.templateId,
        updateColumnRequest: {
            orderMap: template.columns,
        },
    })), [apiDispatch]);

    return useCommonEventHook({eventAction, onSuccess, onFail});
};
